/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext } from "react";
import { useSelector } from "react-redux";
import CreditBalanceOverviewPanelComponent from "./creditBalanceOverviewPanel.component";
import { selectLoading } from "modules/notification";
import { getCreditOverview } from "modules/campaign/consumer-engagement/redux";
import { TngDisbursementContext } from "../tngDisbursementSettingPanel/tngDisbursementSettingPanel.container";

export default function CreditBalanceOverviewPanelContainer() {
  const lang = useSelector((state) => state.constant.languages);
  const isFetching = useSelector((state) =>
    selectLoading(state, getCreditOverview.typePrefix)
  );

  const { disbursementInfo, overview, isError, handleOverviewDataLoad } =
    useContext(TngDisbursementContext);

  return (
    <CreditBalanceOverviewPanelComponent
      lang={lang}
      isFetching={isFetching}
      isError={isError}
      handleReload={handleOverviewDataLoad}
      overview={overview}
      disbursementInfo={disbursementInfo}
    />
  );
}
